// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d329cdb9","815":"b7053035","906":"fe9fd107","935":"45404fac"}[chunkId] + ".chunk.js";
};